import { IActionMap } from '@omaze/redux';

import { createEmailCaptureActionType } from './email-capture.factories';

interface IEmailCaptureAction extends IActionMap {
    SIGN_UP_EMAIL_CAPTURE_START: string;
    SIGN_UP_EMAIL_CAPTURE_SUCCESS: string;
    SIGN_UP_EMAIL_CAPTURE_ERROR: string;
    RESET_EMAIL_CAPTURE: string;
    RESET_EMAIL_CAPTURE_WITH_DELAY_START: string;
    RESET_EMAIL_CAPTURE_WITH_DELAY_SUCCESS: string;
    VALIDATE_EMAIL_CAPTURE_START: string;
    VALIDATE_EMAIL_CAPTURE_SUCCESS: string;
    VALIDATE_EMAIL_CAPTURE_ERROR: string;
}

export const EMAIL_CAPTURE_ACTION: IEmailCaptureAction = {
    SIGN_UP_EMAIL_CAPTURE_START: createEmailCaptureActionType('signup', 'emailcapture', 'start'),
    SIGN_UP_EMAIL_CAPTURE_SUCCESS: createEmailCaptureActionType('signup', 'emailcapture', 'success'),
    SIGN_UP_EMAIL_CAPTURE_ERROR: createEmailCaptureActionType('signup', 'emailcapture', 'error'),
    RESET_EMAIL_CAPTURE: createEmailCaptureActionType('reset', 'emailcapture', 'default'),
    RESET_EMAIL_CAPTURE_WITH_DELAY_START: createEmailCaptureActionType('reset', 'emailcapture', 'start'),
    RESET_EMAIL_CAPTURE_WITH_DELAY_SUCCESS: createEmailCaptureActionType('reset', 'emailcapture', 'success'),
    VALIDATE_EMAIL_CAPTURE_START: createEmailCaptureActionType('validate', 'emailcapture','start'),
    VALIDATE_EMAIL_CAPTURE_SUCCESS: createEmailCaptureActionType('validate', 'emailcapture','success'),
    VALIDATE_EMAIL_CAPTURE_ERROR: createEmailCaptureActionType('validate', 'emailcapture','error'),
};
